import { Box, Flex, Heading } from '@chakra-ui/react'
import UserManualCard from '../components/UserManualCard'

const UserManualPage = () => {
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="300px" p="5">
      <Flex p={5} mb="3">
        <Heading> User Manual Setting </Heading>
      </Flex>
      <Flex direction="column" gap="3">
        <UserManualCard title="User Manual For External Users" userManualType={"external"}/>
        <UserManualCard title="User Manual For Internal Users" userManualType={"internal"}/>

      </Flex>
    </Box>
  )
}

export default UserManualPage
